
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/mergeRowsAndColumns/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-merge-rows-and-columns-demo-base"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/mergeRowsAndColumns/index.md?type=demo')
};